import React from 'react';
import CloseRounded from '@mui/icons-material/CloseRounded';
import {
  Box,
  CircularProgress,
  IconButton,
  Link,
  Stack,
  Typography,
} from '@mui/material';
import PropTypes from 'prop-types';

import { styles } from './index.styles';

export const FILE_DISPLAY_DATA_TEST_ID = 'file-display';

const FileDisplay = ({ file, onDelete }) => (
  <Box sx={styles.fileDisplay} data-test-id={FILE_DISPLAY_DATA_TEST_ID}>
    <Box sx={styles.cardWrapper}>
      <Link
        sx={styles.card(!!file.file)}
        href={file.file}
        target="_blank"
        rel="noopener noreferrer"
        download
      >
        {file.thumbnail ? (
          <Box sx={styles.cardImage(file.thumbnail)} data-test-id="thumbnail" />
        ) : (
          <Stack
            direction="column"
            sx={{ justifyContent: 'center', height: '100%' }}
          >
            <Typography sx={styles.cardExtension}>{file.extension}</Typography>
          </Stack>
        )}
        <IconButton
          size="small"
          disableRipple
          sx={styles.cardDelete}
          onClick={(event) => {
            event.stopPropagation();
            event.preventDefault();
            onDelete();
          }}
        >
          <CloseRounded color="primary" fontSize="small" />
        </IconButton>
        {(file.deleting || !file.file) && (
          <Box sx={styles.loadingIndicator}>
            <CircularProgress />
          </Box>
        )}
      </Link>
    </Box>
    <Box sx={styles.filename} title={file.name}>
      {file.name}
    </Box>
  </Box>
);

FileDisplay.propTypes = {
  file: PropTypes.shape({
    name: PropTypes.string.isRequired,
    extension: PropTypes.string.isRequired,
    file: PropTypes.string,
    thumbnail: PropTypes.string,
    deleting: PropTypes.bool,
  }).isRequired,
  onDelete: PropTypes.func.isRequired,
};

export default FileDisplay;
